import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  if($(window).width()>=768){
    $('.section1>b').css('transform','translateY('+ scroH / 3 +'px)')
  }
});